import styles from "./ConfirmModal.module.css";

function ConfirmModal({ message, onConfirm, onCancel }) {
    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <h3>Confirmação</h3>

                <p>{message}</p>

                <div className={styles.actions}>
                    <button 
                        className={styles.cancel}
                        onClick={onCancel}
                    >
                        Cancelar
                    </button>

                    <button 
                        className={styles.confirm}
                        onClick={onConfirm}
                    >
                        Sair
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;